class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

 createProduct(p) {
  let formattedPrice = (p.price / 100).toFixed(2); // Assuming price is in cents

  let productPath = window.currentLocale ? `/${window.currentLocale}/products/${p.handle}` : `/products/${p.handle}`;

  let itemComponent = `
    <a href="${productPath}" class="product-card-link" aria-label="View ${p.title}">
      <div class="card-product card-carousel-js swiper-slide" data-handle="${p.handle}" style="height: auto" data-type="inspired">
 <img class="related-product-img card-product__image" src="${p.images[0]}" alt="${p.title} - view product" style="width: 200px"/>
        <div style="margin-top: auto; width:100%;">
          <h6 class="related-product-name card-product__heading">${p.title}</h6>
          <span class="card-product__price">£${formattedPrice}</span>
          <a href="${productPath}" class="button button--primary button--primary--alternate">View</a>
        </div>
      </div>
    </a>
  `;

  return itemComponent;
}

  connectedCallback() {
    const _id = this.getAttribute("data-id");
    const _limit = this.getAttribute("data-count") || 4;

    fetch(
      window.Shopify.routes.root +
        `recommendations/products.json?product_id=${_id}&limit=${_limit}&intent=related`,
    )
      .then((response) => response.json())
      .then(({products}) => {
        if (products.length > 0) {
          this.querySelector('#recommend-heading').classList.remove('visually-hidden');
          products.map((p, i) => {
            this.querySelector("#recommended-products-inect").innerHTML += this.createProduct(p);
          });
        }
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);
